import gql from 'graphql-tag';

export default gql`
    mutation UpdateInventoryWeight($input: UpdateInventoryWeightInput) {
        updateInventoryWeight(input: $input) {
            errors
        }
    }
`;
